import {useTranslation} from 'react-i18next';
import * as css from './SubscriptionPage.css';
import PageWrapper from '../components/pageWrapper/PageWrapper';


function SubscriptionPage() {
    const {t} = useTranslation('subscription');
    const layoutT = useTranslation('layout');    
    return (
        <css.container>
            <PageWrapper
                image=""
                operations={[]}
                leftTitle={layoutT.t('subscription')} className={undefined} SubMenuChildren={undefined} subMenuProps={undefined} routing={undefined} mobileActions={undefined}            >
                <css.main>
                    <css.leftContainer>
                        <css.header>
                            <css.title>{t('subscriptionsPageTitle')}</css.title>
                            <css.subtitle>{t('subscriptionsPageSubtitle')}</css.subtitle>
                        </css.header>
                    </css.leftContainer>
                </css.main>
            </PageWrapper>
        </css.container>
    );
}

export default SubscriptionPage;
